/* eslint-disable implicit-arrow-linebreak */
import apiAgent from './agent'

import { getCockpitCookie } from './cockpit'

export const DEFAULT_AUTH_SCHEME = 'Bearer'

export const DEFAULT_AUTH_HEADER = 'Authorization'

export const getDefaultAuthToken = () => getCockpitCookie()

export const getDefaultAuthHeader = () =>
  `${DEFAULT_AUTH_SCHEME} ${getDefaultAuthToken()}`

export const isAPIError = ({ data = {} }) =>
  !!(data.error && (data.code || data.message))

export const request = (method, endpoint, options = {}) =>
  new Promise((resolve, reject) => {
    const requestConfig = {
      method,
      headers: {},
      url: endpoint,
      ...options
    }

    const { headers = {}, baseURL } = requestConfig

    if (baseURL) {
      apiAgent.defaults.baseURL = baseURL

      // eslint-disable-next-line no-param-reassign
      delete requestConfig.baseURL
    }

    if (!headers.Authorization) {
      requestConfig.headers[DEFAULT_AUTH_HEADER] = getDefaultAuthHeader()
    }

    apiAgent
      .request(requestConfig)
      .then((res) => {
        const { data = {} } = res

        // The remote API can returns `200 OK` even in case of errors(example: 404)
        // So the `catch` handler is never called, we need to do it manually here
        // TODO: This should be removed
        if (isAPIError(res)) return reject(data)

        return resolve(data)
      })
      .catch((err) => {
        const { response = {} } = err

        // Keep compatibility by still returning a Promise
        return reject(err)
      })
  })

export const get = (endpoint, requestConfig = {}) =>
  request('get', endpoint, requestConfig)

export const post = (endpoint, requestConfig = {}) =>
  request('post', endpoint, requestConfig)

export const del = (endpoint, requestConfig = {}) =>
  request('delete', endpoint, requestConfig)

export const patch = (endpoint, requestConfig = {}) =>
  request('patch', endpoint, requestConfig)

export const getAuthorizationHeaderValue = (
  authToken,
  authScheme = DEFAULT_AUTH_SCHEME
) => {
  if (authScheme) {
    return `${authScheme} ${authToken}`
  }

  return authToken
}

export const getAuthorizationHeader = (
  authToken,
  authHeader = DEFAULT_AUTH_HEADER,
  authScheme = DEFAULT_AUTH_SCHEME
) => {
  // Don't create the header if there is no value to associate with it
  if (!authToken) return {}

  return {
    [authHeader]: getAuthorizationHeaderValue(authToken, authScheme)
  }
}

export const getAuthenticatedRequestConfig = (
  baseURL,
  authToken,
  authHeader = DEFAULT_AUTH_HEADER,
  authScheme = DEFAULT_AUTH_SCHEME,
  params = {}
) => {
  const requestConfig = {
    baseURL,
    headers: {
      ...getAuthorizationHeader(authToken, authHeader, authScheme),
      ...params.headers
    }
  }

  return {
    ...params,
    ...requestConfig
  }
}

export { apiAgent }

export default request
